const MAP = {
  pending: { label: "Menunggu", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  prospective: { label: "Calon Jamaah", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  submitted: { label: "Diajukan", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  registered: { label: "Terdaftar", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  approved: { label: "Disetujui", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  verified: { label: "Terverifikasi", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  active: { label: "Aktif", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  fully_paid: { label: "Lunas", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  completed: { label: "Selesai", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  rejected: { label: "Ditolak", cls: "bg-red-50 text-red-700 border-red-200" },
  needs_revision: { label: "Perlu Diperbaiki", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  correction: { label: "Perlu Perbaikan", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  cancelled: { label: "Dibatalkan", cls: "bg-red-50 text-red-700 border-red-200" },
  published: { label: "Dipublikasikan", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  draft: { label: "Draf", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  archived: { label: "Diarsipkan", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  upcoming: { label: "Mendatang", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  today: { label: "Hari Ini", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  paid: { label: "Komisi Dibayar", cls: "bg-[#FEF3C7] text-[#92720C] border-[#F5B700]/40" },
};

export default function StatusBadge({ status, testId }) {
  const info = MAP[status] || { label: status, cls: "bg-slate-100 text-slate-700 border-slate-200" };
  return (
    <span
      data-testid={testId || `status-badge-${status}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-medium capitalize ${info.cls}`}
    >
      {info.label}
    </span>
  );
}
